export const qaNotes = {
  qaNote: "Qa Note",
  notPartOfEval: "Note is not part of the evaluation",
  charLeft: "characters available",
  updatedBy: "QA note updated by {{user}} on {{date}}",
  createNewNote: "Create a QA note",
  qaNotePlaceHolder: "Add note here"
};
